module.exports = __webpack_public_path__ + "static/hobbies-afd845ba204261408dc99c7aa4c19d5e.png";